import React, { useState } from 'react';
import './Dashboard.css';

function Dashboard() {
  const [isFlashing, setIsFlashing] = useState(false);

  const handleClick = () => {
    setIsFlashing(true);

    // Wait 4 seconds before redirecting to RingCentral Join Page
    setTimeout(() => {
      window.location.href = "https://v.ringcentral.com/welcome/join/";
    }, 4000);
  };

  return (
    <div className="dashboard-container">
      <div className="login-container animate-in">
        <img src="/seal.png" alt="Graystone Construction Seal" className="seal" />
        <h1 className="dashboard-title">Graystone Construction & Calimesa Turf Center</h1>
        <h2 className="dashboard-subtitle">Staff & Contractor Portal</h2>

        <form className="login-form">
          <div className="form-group">
            <label htmlFor="email">Work Email (Staff / Contractor)</label>
            <input type="email" id="email" placeholder="Enter your work email" required />
          </div>

          <div className="form-group">
            <label htmlFor="password">Portal Password</label>
            <input type="password" id="password" placeholder="Enter your password" required />
          </div>

          <button type="submit" className="login-button">Access Portal</button>
        </form>

        <div className="forgot-password">
          <a href="/forgot-password">Need Help Logging In?</a>
        </div>
      </div>

      {/* Quick Call Button – Connects to Graystone Team */}
      <button className={`robot-btn ${isFlashing ? 'flashing' : ''}`} onClick={handleClick}>
        📞
      </button>
    </div>
  );
}

export default Dashboard;